module.exports = __webpack_public_path__ + "static/media/article_32_blue.6ee6b55e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/article_32_blue.svg
// module id = 616
// module chunks = 0